import SuperRepository from '../superRepository'

export default new (class PaymentInvoicesRepository extends SuperRepository {
  baseUri() {
    return 'payment_invoice'
  }
  preview = ({ signal, ...data }) => this.httpClient().post(`${this.baseUri()}/preview`, data, { signal })
})()
